import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

import { storeSet } from '../../../../store';
import AuthenticationService from '../../../../service/authentication-service';
import FormField from '../../../../components/FormField';
import ButtonFlatAccent from '../../../../components/ButtonWrapper/components/ButtonFlatAccent';
import ButtonFlatWarning from '../../../../components/ButtonWrapper/components/ButtonFlatWarning';

import '../../../../assets/components/ProfileSecurity.css';

const ProfileSecurity = () => {
    const { control, handleSubmit, reset } = useForm({
        mode: 'onChange',
        defaultValues: {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
        },
    });
    const [message, setMessage] = useState(null);
    const [deleting, setDeleting] = useState(false);

    const onPasswordSubmit = async (data) => {
        setMessage(null);
        if (data.newPassword !== data.confirmPassword) {
            setMessage({ type: 'err', text: __('Le password non coincidono', 'soundbetween') });
            return;
        }
        try {
            await AuthenticationService.changePasswordAsync({
                currentPassword: data.currentPassword,
                newPassword: data.newPassword,
            });
            setMessage({ type: 'ok', text: __('Password aggiornata', 'soundbetween') });
            reset();
        } catch (e) {
            setMessage({ type: 'err', text: __('Password attuale errata o nuova password non valida', 'soundbetween') });
        }
    };

    const handleDeleteAccount = async () => {
        const confirmed = window.confirm(
            __("Eliminare l'account? L'azione e irreversibile: progetti e dati saranno cancellati.", 'soundbetween')
        );
        if (!confirmed || deleting) return;
        setDeleting(true);
        try {
            await AuthenticationService.deleteAccountAsync();
            storeSet('token', '');
            window.location.replace('/login');
        } catch (e) {
            setDeleting(false);
            window.alert(__("Impossibile eliminare l'account. Riprova.", 'soundbetween'));
        }
    };

    return (
        <div className="workbenchProfile workbenchProfile--security">

            {/* Change Password */}
            <section className="profileSecurity__section" aria-labelledby="security-password-heading">
                <h4 id="security-password-heading" className="workbenchProfile__sectionTitle">
                    {__('Cambia Password', 'soundbetween')}
                </h4>
                <div className="profileSecurity__card">
                    <form className="appForm" onSubmit={handleSubmit(onPasswordSubmit)} noValidate>
                        <fieldset className="profileSecurity__passwordRow">
                            <FormField
                                type="password"
                                name="currentPassword"
                                label={__('Password Attuale', 'soundbetween')}
                                placeholder={__('Password Attuale', 'soundbetween')}
                                control={control}
                                rules={{ required: __('Campo obbligatorio', 'soundbetween') }}
                            />
                            <FormField
                                type="password"
                                name="newPassword"
                                label={__('Nuova Password', 'soundbetween')}
                                placeholder={__('Nuova Password', 'soundbetween')}
                                control={control}
                                rules={{ required: __('Campo obbligatorio', 'soundbetween') }}
                            />
                            <FormField
                                type="password"
                                name="confirmPassword"
                                label={__('Conferma Password', 'soundbetween')}
                                placeholder={__('Conferma Password', 'soundbetween')}
                                control={control}
                                rules={{ required: __('Campo obbligatorio', 'soundbetween') }}
                            />
                        </fieldset>
                        {message && (
                            <p className={`profileSecurity__message profileSecurity__message--${message.type}`}>
                                {message.text}
                            </p>
                        )}
                        <div className="appFormActions">
                            <ButtonFlatAccent size="md">
                                {__('Aggiorna Password', 'soundbetween')}
                            </ButtonFlatAccent>
                        </div>
                    </form>
                </div>
            </section>

            {/* Danger Zone */}
            <section className="profileSecurity__section" aria-labelledby="security-danger-heading">
                <h4 id="security-danger-heading" className="workbenchProfile__sectionTitle">
                    {__('Zona Pericolosa', 'soundbetween')}
                </h4>
                <div className="profileSecurity__card profileSecurity__card--danger">
                    <div className="profileSecurity__dangerRow">
                        <div className="profileSecurity__dangerInfo">
                            <strong className="profileSecurity__dangerTitle">
                                {__('Elimina Account', 'soundbetween')}
                            </strong>
                            <p className="profileSecurity__dangerDesc">
                                {__('Questa azione e irreversibile. Tutti i tuoi dati, progetti e impostazioni verranno eliminati definitivamente.', 'soundbetween')}
                            </p>
                        </div>
                        <ButtonFlatWarning size="md" disabled={deleting} onClick={handleDeleteAccount}>
                            {__('Elimina Account', 'soundbetween')}
                        </ButtonFlatWarning>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default ProfileSecurity;
